// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___XhM6","rootMobile":"styles_rootMobile__2DW2I"};